//-- Compat Code
require("@babel/polyfill");
import "proxy-polyfill";
if (!window.location.origin) {
    window.location.origin = window.location.protocol 
        + "//" 
        + window.location.hostname 
        + (
            window.location.port ? ":" + window.location.port : ""
        ); 
}
require("promise.prototype.finally").shim();
//----

import {getLogger} from "@mm/log";
import { registerLogger, registerKeydownStarter } from "./debug/DebugListener";
import ioq from "query-parse";
import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";

import ApeirosProgress from "@apeiros/react-common/ApeirosProgress";
import AppTheme from "./theme/AppTheme";

const uri = window.location.href.replace(/#.*/, "");
const query = uri.substring(uri.indexOf("?") + 1, uri.length);
const options = ioq.toObject(query);

if (options.debug) {
    registerLogger();
} else {
    registerKeydownStarter(document.getElementById("container"));
}

const LOGGER = getLogger("frontend-ng/main");

LOGGER.trace("main start");

import "./styles/app.scss";

ReactDOM.render(
    <AppTheme><ApeirosProgress /></AppTheme>,
    document.getElementById("loading")
);

require("bundle-loader!./app.js")(
    (fullapp) => {
        fullapp.getApp()
            .then((app) => {
                ReactDOM.render(app, document.getElementById("container"));
            })
        ;
    }
);
